import React, { createRef, useLayoutEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import HighChartsMore from 'highcharts/highcharts-more';
import HighChartsNoData from 'highcharts/modules/no-data-to-display';
import Utils from '../../../../utils/Utils';

function ChartAdapter(props) {
  initReactHighCharts();

  let chartEnhanced = createRef();

  useLayoutEffect(() => {
    let chart = chartEnhanced.current ? chartEnhanced.current.chart : null;

    if (chart) {
      chart.options.exporting.sourceWidth = chart.chartWidth;
      chart.options.exporting.sourceHeight = chart.chartHeight;
      chart.options.exporting.filename = chart.title.textStr + 'Chart';
      chart.options.zoomType = false;
    }
  });

  return (
    <div className="chart-wrapper" data-qa="qa-chart">
      {props.settings.Name && props.settings.Name.charAt(0) != '_' ? (
        <h4 className="u-ml-full">{props.settings.Name}</h4>
      ) : null}
      <HighchartsReact
        options={props.settings.Configuration}
        ref={chartEnhanced}
        highcharts={Highcharts}
        immutable={true}
        constructorType="chart"
      />
    </div>
  );
}

function initReactHighCharts() {
  if (typeof Highcharts === 'object') {
    HighChartsMore(Highcharts);
    HighchartsExporting(Highcharts);
    HighChartsMore(Highcharts);
    HighChartsNoData(Highcharts);

    Highcharts.dateFormats = {
      E: Utils.determineDaysHourMinSecFromTicks,
    };

    Highcharts.setOptions({
      lang: {
        noData: 'No data to show within selected time range',
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              'printChart',
              'separator',
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
            ],
          },
        },
      },
    });

    Highcharts.defaultOptions.credits.enabled = false;
  }
}

export default ChartAdapter;
